import React from "react";
import "../styles/services.css";
import {
  FaLaptopCode,
  FaGasPump,
  FaPrint,
  FaDesktop,
  FaArrowRight,
} from "react-icons/fa";

const services = [
  {
    icon: <FaLaptopCode />,
    title: "Accounts ERP",
    desc:
      "Complete accounting software for petrol pumps with balance sheet, profit & loss, inventory, cash flow and financial reports.",
  },
  {
    icon: <FaGasPump />,
    title: "Nozzle Automation",
    desc:
      "Monitor live fuel sales, tank stock, nozzle status and operator activities in real time.",
  },
  {
    icon: <FaPrint />,
    title: "Fuel Receipt Printing",
    desc:
      "Generate computerized receipts automatically after every fueling transaction.",
  },
  {
    icon: <FaDesktop />,
    title: "External Display",
    desc:
      "Display fuel amount and quantity on a large external screen for customer visibility.",
  },
];

const Services = () => {
  return (
    <section className="services" id="services">

      <div className="section-title">

        <span>OUR SOLUTIONS</span>

        <h2>Technology That Powers Modern Fuel Stations</h2>

        <p>
          We develop reliable software and hardware solutions that help fuel
          stations operate faster, smarter and more efficiently.
        </p>

      </div>

      <div className="services-grid">

        {services.map((service, index) => (

          <div className="service-card" key={index}>

            <div className="service-icon">
              {service.icon}
            </div>

            <h3>{service.title}</h3>

            <p>{service.desc}</p>

            <button>
              Learn More
              <FaArrowRight />
            </button>

          </div>

        ))}

      </div>

    </section>
  );
};

export default Services;